<template>
  <div>
    <!-- 教科書選択 -->
    <v-section-panel useBreak v-if="!$store.getters.selectedSubjectOptionIsPublisherNone">
      <template v-slot:title> {{calcSortNo(3)}}.教科書を選択してください。</template>
      <template v-slot:content>
        <v-choice-publishers/>
      </template>
    </v-section-panel>

    <!-- 教科書範囲 -->
    <v-section-panel useBreak v-if="!$store.getters.selectedSubjectOptionIsPublisherNone">
      <template v-slot:title> {{calcSortNo(4)}}.教科書範囲を指定してください。</template>
      <template v-slot:content>
        <v-publisher-pages-group/>
      </template>
    </v-section-panel>

    <!-- 競技選択 -->
    <v-section-panel useBreak v-if="$store.getters.selectedSubjectOptionIsTaiiku">
      <template v-slot:title> {{calcSortNo(4)}}.競技を選択してください。</template>
      <template v-slot:content>
        <v-choice-athletic-events/>
      </template>
    </v-section-panel>

    <!-- 配点選択 -->
    <v-section-panel useBreak>
      <template v-slot:title> {{calcSortNo(5)}}.配点を選択してください</template>
      <template v-slot:content>
        <p class="attention" v-if="selectedSubjectHasChild && sendApiParams.length > 1">
          ※{{ selectedRootSubjectName }}全体の配点です。分野ごとの配点設定はできません。
        </p>
        <v-choice-max-point/>
      </template>
    </v-section-panel>

    <!-- 前学年範囲選択 -->
    <!-- <v-section-panel useBreak v-if="showBeforeGradeOption">
      <template v-slot:title> 6.前学年内容</template>
      <template v-slot:content>
        <v-before-grade-content/>
      </template>
    </v-section-panel> -->


    <!-- 小問数選択 -->
    <v-section-panel useBreak>
      <template v-slot:title>
        {{calcSortNo(6)}}.小問数を入力してください（{{selectedSubjectHasChild && sendApiParams.length > 1 ? '合計' : ''}}{{maxQuestionNum}}問以下）
      </template>
      <template v-slot:content>
        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols=5>
              <v-question-num/>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-section-panel>

    <!-- 難易度選択 -->
    <v-section-panel useBreak v-if="!$store.getters.selectedSubjectIsSkill">
      <template v-slot:title> {{calcSortNo(7)}}.難易度を選択してください。</template>
      <template v-slot:content>
        <v-choice-difficulty/>
      </template>
    </v-section-panel>

    <!-- 「主体的に学習に取り組む態度」筆記問題 選択 -->
    <v-section-panel
      :useBreak="!$store.getters.selectedSubjectHasChild"
      v-if="!$store.getters.selectedSubjectIsSkill"
    >
      <template v-slot:title> {{calcSortNo(8)}}.「主体的に学習に取り組む態度」筆記問題</template>
      <template v-slot:content>
        <v-choice-writing-question/>
      </template>
    </v-section-panel>

  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoicePublishers from '@/components/molecules/ChoicePublishers'
import VPublisherPagesGroup from '@/components/molecules/PublisherPagesGroup'
import VChoiceMaxPoint from '@/components/molecules/ChoiceMaxPoint'
import VQuestionNum from '@/components/molecules/QuestionNum'
import VChoiceDifficulty from '@/components/molecules/ChoiceDifficulty'
import VChoiceWritingQuestion from '@/components/molecules/ChoiceWritingQuestion'
import VChoiceAthleticEvents from '@/components/molecules/ChoiceAthleticEvents'
import { mapGetters } from 'vuex'

export default {
  components: {
    VSectionPanel,
    VChoicePublishers,
    VPublisherPagesGroup,
    VChoiceMaxPoint,
    VQuestionNum,
    VChoiceDifficulty,
    VChoiceWritingQuestion,
    VChoiceAthleticEvents,
  },

  data: () => ({
    rules: [
      value => !value.match(/[^0-9]/) || '数字のみで入力してください',
    ],
  }),

  computed: {
    ...mapGetters([
      'selectedSubjectIsKokugo',
      'selectedSubjectHasChild',
      'sendApiParams',
      'selectedSubjectOptionIsPublisherNone',
      'selectedSubjectOptionIsTaiiku',
      'maxQuestionNum',
    ]),

    // flags
    showBeforeGradeOption() {
      return !this.$store.getters.selectedGradeIsMinimum;
    },

    selectedRootSubjectName() {
      return this.$store.getters['master/subjectRoot'](
        this.$store.state.top.selectedSubject.id
      ).name
    }
  },

  methods: {
    calcSortNo(sortNo){
      let chgNo = this.selectedSubjectHasChild ? sortNo-1 : sortNo
      if (this.selectedSubjectOptionIsPublisherNone) {
        if (this.selectedSubjectOptionIsTaiiku) {
          chgNo -= 1
        }else {
          chgNo -= 2
        }
      }
      return chgNo
    }
  },
}
</script>>

<style lang="stylus" scoped>
.attention
  font-size 13px !important
</style>
